<template>
  <v-dialog :value="value" max-width="620" :persistent="creating" @input="$emit('input', $event)">
    <v-card class="report-create-dialog">
      <v-card-title class="report-create-heading">Отчёт по клиентам<v-spacer /><v-btn icon :disabled="creating" title="Закрыть" aria-label="Закрыть создание отчёта" @click="$emit('input', false)"><v-icon>mdi-close</v-icon></v-btn></v-card-title>
      <v-card-text>
        <v-alert v-if="error" dense text type="error">{{ error }}</v-alert>
        <template v-if="fromClients">
          <v-radio-group v-model="scope" :disabled="creating" class="report-scope mt-0" hide-details>
            <v-radio :label="allScopeLabel" value="all" />
            <v-radio :label="'Только страница ' + page + ' (до ' + perPage + ' клиентов)'" value="page" />
          </v-radio-group>
          <div v-if="activeFilters.length" class="report-filter-heading">Выбранные фильтры</div>
          <dl v-if="activeFilters.length" class="report-create-filters"><div v-for="filter in activeFilters" :key="filter.key"><dt>{{ filter.label }}</dt><dd>{{ filter.value }}</dd></div></dl>
          <div v-else class="report-no-filters">Фильтры не заданы</div>
        </template>
        <template v-else>
          <v-text-field v-model="form.search" label="Поиск клиента" outlined dense clearable :disabled="creating" maxlength="200" />
          <v-select v-model="form.app" :items="apps" label="Приложение" outlined dense clearable :disabled="creating" />
          <v-row><v-col cols="12" sm="6" class="py-0"><v-text-field v-model="form.createdAtFrom" type="date" label="Регистрация от" outlined dense :disabled="creating" /></v-col><v-col cols="12" sm="6" class="py-0"><v-text-field v-model="form.createdAtTo" type="date" label="Регистрация до" outlined dense :disabled="creating" /></v-col></v-row>
        </template>
      </v-card-text>
      <v-card-actions class="px-6 pb-5 report-create-actions"><v-btn text :disabled="creating" @click="$emit('input', false)">Отмена</v-btn><v-spacer /><v-btn class="btn-primary" :loading="creating" :disabled="creating" @click="create"><v-icon left small>mdi-file-excel-outline</v-icon>Сформировать</v-btn></v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ReportService, {CLIENT_REPORT_COLUMNS, reportError, requestKey} from '../../api/ReportService'

const labels = {
  search: 'Поиск', app: 'Приложение', blocked: 'Заблокирован', no_cash_payment: 'Без наличных',
  createdAtFrom: 'Регистрация от', createdAtTo: 'Регистрация до', lastBuyAtFrom: 'Последний заказ от', lastBuyAtTo: 'Последний заказ до',
  firstOrderFrom: 'Первый заказ от', firstOrderTo: 'Первый заказ до', ordersSumFrom: 'Сумма заказов от', ordersSumTo: 'Сумма заказов до',
  ordersCountFrom: 'Количество заказов от', ordersCountTo: 'Количество заказов до', cashBackFrom: 'Кешбэк от', cashBackTo: 'Кешбэк до',
}

export default {
  name: 'ReportCreateDialog',
  props: {value: Boolean, fromClients: Boolean, filters: {type: Object, default: () => ({})}, columns: {type: Array, default: () => CLIENT_REPORT_COLUMNS.slice()}, page: {type: Number, default: 1}, perPage: {type: Number, default: 15}, total: {type: Number, default: null}},
  data: () => ({scope: 'all', form: {search: '', app: '', createdAtFrom: '', createdAtTo: ''}, creating: false, error: '', key: '', apps: ['IOS', 'Android', 'Есть приложение', 'Без приложения']}),
  computed: {
    allScopeLabel() {
      return (this.activeFilters.length ? 'Все найденные клиенты' : 'Все клиенты') + (this.total !== null ? ' (' + Number(this.total).toLocaleString('ru-RU') + ')' : '')
    },
    activeFilters() {
      return Object.keys(labels).filter(key => this.filters[key] !== null && this.filters[key] !== undefined && this.filters[key] !== '').map(key => ({key, label: labels[key], value: typeof this.filters[key] === 'boolean' ? (this.filters[key] ? 'Да' : 'Нет') : this.filters[key]}))
    },
  },
  watch: {
    value(open) { if (open) { this.error = ''; this.scope = 'all'; this.key = requestKey(); this.form = {search: '', app: '', createdAtFrom: '', createdAtTo: ''} } },
    scope() { if (!this.creating) this.key = requestKey() },
    form: {deep: true, handler() { if (!this.creating) this.key = requestKey() }},
    columns: {deep: true, handler() { if (!this.creating) this.key = requestKey() }},
  },
  methods: {
    async create() {
      if (this.creating) return
      this.creating = true; this.error = ''
      try {
        const response = await ReportService.create({type: 'clients', scope: this.fromClients ? this.scope : 'all', filters: this.fromClients ? this.filters : this.form, columns: this.columns.slice(), page: this.page, perPage: this.perPage, request_key: this.key || (this.key = requestKey())})
        this.$emit('created', response.data)
        this.$emit('input', false)
      } catch (error) { this.error = await reportError(error, 'Не удалось поставить отчёт в очередь. Попробуйте ещё раз.') }
      finally { this.creating = false }
    },
  },
}
</script>

<style scoped>
.report-create-heading { font-size: 22px; line-height: 1.35; word-break: break-word; padding: 20px 24px; }
.report-scope { padding-top: 4px; margin-bottom: 16px; }
.report-scope ::v-deep .v-radio { align-items: flex-start; min-height: 32px; }
.report-scope ::v-deep .v-label { position: static !important; top: auto !important; transform: none !important; font-size: 14px; line-height: 24px; color: #354351; min-width: 0; text-align: left; }
.report-scope ::v-deep .v-input--selection-controls__input { flex: 0 0 24px; margin-right: 10px; }
.report-filter-heading { font-size: 13px; font-weight: 600; color: #354351; margin-bottom: 6px; }
.report-create-filters > div { display: grid; grid-template-columns: 1fr 1.4fr; gap: 12px; padding: 5px 0; }
.report-create-filters dt, .report-no-filters { color: #74808c; font-size: 13px; }
.report-create-filters dd { margin: 0; color: #263441; overflow-wrap: anywhere; }
.report-create-actions { gap: 8px; flex-wrap: wrap; }
.report-create-actions .v-btn { letter-spacing: 0; }
</style>
